import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../../store";
// Define a type for the slice state

// Define the initial state using that type

const leaveCalendarSlice = createSlice({
  name: "leaveCalendar",

  initialState: { leaveCalendar: [], leaveCalendarLoader: false },
  reducers: {
    setLeaveCalendarData: (state: any, action: PayloadAction<any>) => {
      state.leaveCalendar = action.payload;
    },
    setLeaveCalendarLoader: (state: any, action: PayloadAction<any>) => {
      state.leaveCalendarLoader = action.payload;
    },
    resetLeaveCalendarData: (state: any) => {
      state.leaveCalendar = [];
    },
  },
});

export const {
  setLeaveCalendarData,
  resetLeaveCalendarData,
  setLeaveCalendarLoader,
} = leaveCalendarSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default leaveCalendarSlice.reducer;
